import { useContext, useEffect, useRef, useState } from "react";
import { Badge, Button, Label, TextInput } from "flowbite-react";
import { UpdateCampaign } from "../../services/creditBonus/creditBonusActions";
import { ResponseContext } from "../../context/responseProvider";
import { CustomModal } from "../../layouts/customModal";
import { StatusContext } from "../../context/statusProvider";

const EditCampaignForm = ({ data }) => {
  const [form, setForm] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { getResponse, setResponse } = useContext(ResponseContext);
  const formRef = useRef(null);
  const response = getResponse("edit_campaign");

  const modalRef = useRef(null);
  const openRef = useRef(null);
  const { handleApi } = useContext(StatusContext);

  const handleClose = () => {
    modalRef.current();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    UpdateCampaign({
      email: localStorage.getItem("userEmail"),
      form,
      setIsLoading,
      setResponse,
      formRef,
      onSuccess: () => {
        handleApi();
        handleClose();
      },
    });
  };

  useEffect(() => {
    setForm(data);
  }, [data]);

  return (
    <CustomModal
      btnText="Edit campaign"
      modalRef={modalRef}
      openRef={openRef}
      closeOnOutsideClick={true}
      customBtn={
        <button
          onClick={() => openRef.current()}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:text-gray-900 transition-colors"
        >
          Edit
        </button>
      }
    >
      <div className="w-full sm:w-[860px]">
        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4">
          Edit campaign
        </h3>
        <div className="st-campaign-form w-full max-h-[80vh] overflow-y-auto">
          <div className="flex h-full flex-col justify-center gap-4 p-6 pl-2">
            <form
              ref={formRef}
              onSubmit={handleSubmit}
              className="flex flex-col gap-6"
            >
              {/* ── Basic info ── */}
              <div className="flex flex-col gap-4">
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <Label htmlFor="agent_based" value="Agent Based" />
                    <TextInput
                      id="agent_based"
                      name="agent_based"
                      placeholder="Agent-based identifier"
                      value={form.agent_based}
                      onChange={handleChange}
                      helperText={
                        <span className="text-xs text-gray-500 mt-1">
                          Separate multiple agent IDs with commas — e.g.{" "}
                          <code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-gray-600">
                            1234, 5678, 9012
                          </code>
                        </span>
                      }
                    />
                  </div>
                </div>
              </div>
              {/* ── Dates and amounts ── */}
              <div className="flex flex-col gap-4">
                <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 pb-1 border-b border-gray-100 dark:border-gray-700">
                  Dates
                </p>

                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label htmlFor="start_date" value="Start Date" />
                    <TextInput
                      id="start_date"
                      name="start_date"
                      type="date"
                      value={form.start_date}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <Label htmlFor="end_date" value="End Date" />
                    <TextInput
                      id="end_date"
                      name="end_date"
                      type="date"
                      value={form.end_date}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <Label htmlFor="credit_end_date" value="Credit End Date" />
                    <TextInput
                      id="credit_end_date"
                      name="credit_end_date"
                      type="date"
                      value={form.credit_end_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  {response?.status === false && (
                    <Badge color="failure">{response?.message}</Badge>
                  )}
                </div>
              </div>

              {/* ── Actions ── */}
              <div className="flex mt-2 items-center justify-between pt-2 border-t border-gray-100 dark:border-gray-700">
                <button
                  type="button"
                  className="text-sm font-semibold text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <Button type="submit" disabled={isLoading}>
                  {isLoading ? "Updating..." : "Update campaign"}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default EditCampaignForm;
